'use client';

import { c as _c } from "react/compiler-runtime";
import { useSessionList } from '@clerk/nextjs';
import { Avatar, AvatarFallback, AvatarImage } from '@extern/ui/avatar';
import { Button } from '@extern/ui/button';
import { useRouter, useSearchParams } from 'next/navigation';
import { useAuthEvents } from '@/app/(auth)/_hooks/use-auth-events';
import { AuthCard } from '@/app/(auth)/_partials/auth-card';
import { useUtmParams } from '@/hooks/use-utm-params';
import { getAllowlistedSearchParams } from '@/utils/get-allowlisted-search-params';
import { getNameInitials } from '@/utils/get-name-initials';
import { resolvePostSignUpRedirectUrl } from '@/utils/resolve-post-sign-up-redirect-url';
import { useSignUpFlowStore } from '../_hooks/use-sign-up-flow-store';
export function SignUpChooseSessionControl() {
  const $ = _c(19);
  const router = useRouter();
  const {
    setActive,
    sessions,
    isLoaded
  } = useSessionList();
  const {
    trackSignUpSessionSelected
  } = useAuthEvents();
  useUtmParams();
  const searchParams = useSearchParams();
  if (!isLoaded) {
    return null;
  }
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <AuthCard.Header><AuthCard.Title>Active sessions</AuthCard.Title></AuthCard.Header>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] !== router || $[2] !== searchParams || $[3] !== sessions || $[4] !== setActive || $[5] !== trackSignUpSessionSelected) {
    let t2;
    if ($[7] !== router || $[8] !== searchParams || $[9] !== setActive || $[10] !== trackSignUpSessionSelected) {
      t2 = session => <div className="flex items-center justify-between gap-4" key={session.id}><Avatar className="h-10 w-10 bg-transparent"><AvatarImage src={session?.publicUserData?.imageUrl} /><AvatarFallback className="text-center font-bold text-3xl">{getNameInitials(`${session?.publicUserData?.firstName} ${session?.publicUserData?.lastName}`)}</AvatarFallback></Avatar><div className="flex flex-1 flex-col gap-1 text-left"><p className="font-medium text-sm leading-none">{`${session?.publicUserData?.firstName} ${session?.publicUserData?.lastName}`}</p><p className="text-muted-foreground text-sm">{session?.publicUserData.identifier}</p></div><Button onClick={async () => {
          if (session?.id && setActive) {
            trackSignUpSessionSelected("existing_session", {
              method: "google"
            });
            useSignUpFlowStore.getState().onChange({
              step: "start"
            });
            const redirectUrl = resolvePostSignUpRedirectUrl(searchParams);
            await setActive({
              session: session.id,
              redirectUrl
            });
            router.push(redirectUrl);
          }
        }}>Access</Button></div>;
      $[7] = router;
      $[8] = searchParams;
      $[9] = setActive;
      $[10] = trackSignUpSessionSelected;
      $[11] = t2;
    } else {
      t2 = $[11];
    }
    t1 = sessions.map(t2);
    $[1] = router;
    $[2] = searchParams;
    $[3] = sessions;
    $[4] = setActive;
    $[5] = trackSignUpSessionSelected;
    $[6] = t1;
  } else {
    t1 = $[6];
  }
  let t2;
  if ($[12] !== searchParams || $[13] !== sessions.length || $[14] !== trackSignUpSessionSelected) {
    t2 = sessions.length === 0 ? <div className="flex flex-col gap-4 text-center"><p className="text-muted-foreground text-sm">No active sessions</p><Button asChild={true}><a href={`/sign-up?${getAllowlistedSearchParams(searchParams)}`} onClick={() => {
          trackSignUpSessionSelected("fallback");
        }}>Continue with a different account</a></Button></div> : null;
    $[12] = searchParams;
    $[13] = sessions.length;
    $[14] = trackSignUpSessionSelected;
    $[15] = t2;
  } else {
    t2 = $[15];
  }
  let t3;
  if ($[16] !== t1 || $[17] !== t2) {
    t3 = <AuthCard>{t0}<AuthCard.Content>{t1}{t2}</AuthCard.Content></AuthCard>;
    $[16] = t1;
    $[17] = t2;
    $[18] = t3;
  } else {
    t3 = $[18];
  }
  return t3;
}